// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Selected-project quality dashboard (pqd). Tokens only, so Cloudlight and Midnight share one sheet. */

.pqd {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 32px;
  min-width: 0;
}

.pqd-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.pqd-muted { color: var(--rt-text-muted); }
.pqd-small { font-size: var(--rt-text-xs); }
.pqd-strong { font-weight: 600; color: var(--rt-text); }
.is-success { color: var(--rt-success); }
.is-danger { color: var(--rt-danger); }

/* ---------- A. Header & filters ---------- */

.pqd-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pqd-header__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.pqd-header__title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.pqd-header__title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--rt-text);
}

.pqd-header__desc {
  margin: 4px 0 0;
  max-width: 72ch;
  color: var(--rt-text-secondary);
  font-size: var(--rt-text-sm);
}

.pqd-header__meta {
  margin: 4px 0 0;
  color: var(--rt-text-muted);
  font-size: var(--rt-text-xs);
}

.pqd-filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 8px;
  border: 1px solid var(--rt-border-subtle);
  border-radius: var(--rt-radius-lg);
  background: var(--rt-surface);
}

.pqd-filters__env { min-width: 180px; }

.pqd-filters__note {
  margin-left: auto;
  color: var(--rt-text-muted);
  font-size: var(--rt-text-xs);
}

.pqd-segmented {
  display: inline-flex;
  padding: 2px;
  border-radius: var(--rt-radius-md);
  background: var(--bg-tertiary);
}

.pqd-segmented__item {
  height: 28px;
  padding: 0 12px;
  border: 0;
  border-radius: calc(var(--rt-radius-md) - 2px);
  background: transparent;
  color: var(--rt-text-secondary);
  font: inherit;
  font-size: var(--rt-text-xs);
  font-weight: 600;
  cursor: pointer;
  transition: background var(--rt-transition), color var(--rt-transition);
}

.pqd-segmented__item:hover { color: var(--rt-text); }

.pqd-segmented__item.is-active {
  background: var(--rt-surface);
  color: var(--rt-primary);
  box-shadow: var(--rt-shadow-sm);
}

.pqd-segmented__item:focus-visible,
.pqd-info:focus-visible,
.pqd-suite:focus-visible,
.pqd-fail-test__name:focus-visible {
  outline: 2px solid var(--rt-primary);
  outline-offset: 2px;
}

.pqd-custom-range {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  color: var(--rt-text-muted);
}

.pqd-date {
  height: 30px;
  padding: 0 8px;
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-sm);
  background: var(--rt-surface);
  color: var(--rt-text);
  font: inherit;
  font-size: var(--rt-text-xs);
  color-scheme: light;
}

[data-theme="dark"] .pqd-date { color-scheme: dark; }

.pqd-field-error {
  color: var(--rt-danger);
  font-size: var(--rt-text-xs);
}

.pqd-hint {
  margin: 0;
  padding: 8px 12px;
  border-radius: var(--rt-radius-md);
  background: var(--info-muted);
  color: var(--rt-info);
  font-size: var(--rt-text-sm);
}

.pqd-spin { animation: pqd-spin 0.9s linear infinite; }

@keyframes pqd-spin {
  to { transform: rotate(360deg); }
}

/* ---------- B. KPI strip ---------- */

.pqd-kpis {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
}

.pqd-kpi-skeleton { min-height: 112px; }

.pqd-kpi-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.pqd-info {
  position: relative;
  display: inline-flex;
  color: var(--rt-text-muted);
  cursor: help;
  border-radius: 50%;
}

.pqd-info__bubble {
  position: absolute;
  z-index: 30;
  left: 50%;
  bottom: calc(100% + 8px);
  width: 240px;
  padding: 8px 10px;
  border-radius: var(--rt-radius-md);
  background: var(--chart-tooltip-bg, #0f172a);
  color: var(--chart-tooltip-text, #f8fafc);
  font-size: 11.5px;
  font-weight: 500;
  line-height: 1.45;
  text-transform: none;
  letter-spacing: 0;
  white-space: normal;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
  transform: translateX(-50%);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 120ms ease;
}

.pqd-info:hover .pqd-info__bubble,
.pqd-info:focus-visible .pqd-info__bubble {
  opacity: 1;
  visibility: visible;
}

/* ---------- Section card ---------- */

.pqd-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  border: 1px solid var(--rt-border-subtle);
  border-radius: 14px;
  background: linear-gradient(180deg, color-mix(in srgb, var(--rt-surface) 94%, #fff) 0%, var(--rt-surface) 100%);
  box-shadow: var(--rt-shadow-sm);
  transition: opacity var(--rt-transition), border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
  overflow: hidden;
  position: relative;
}

.pqd-card::before {
  content: '';
  position: absolute;
  inset: 0 0 auto 0;
  height: 2px;
  background: linear-gradient(90deg, var(--rt-primary, #2563eb), transparent 80%);
  opacity: 0.7;
  pointer-events: none;
}

.pqd-card:hover {
  border-color: color-mix(in srgb, var(--rt-primary, #2563eb) 22%, var(--rt-border-subtle));
  box-shadow: 0 14px 28px -18px rgba(15, 23, 42, 0.28);
  transform: translateY(-1px);
}

.pqd-card--refreshing { opacity: 0.72; }

.pqd-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px 0;
}

.pqd-card__title {
  margin: 0;
  font-size: var(--rt-text-base);
  font-weight: 700;
  letter-spacing: -0.015em;
  color: var(--rt-text);
}

.pqd-card__subtitle {
  margin: 2px 0 0;
  color: var(--rt-text-muted);
  font-size: var(--rt-text-xs);
}

.pqd-card__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.pqd-card__body {
  padding: 12px 16px 16px;
  min-width: 0;
  flex: 1 1;
}

.pqd-skeleton {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 0;
}

.pqd-state {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 14px;
  border: 1px dashed var(--rt-border);
  border-radius: var(--rt-radius-md);
  color: var(--rt-text-secondary);
  font-size: var(--rt-text-sm);
}

.pqd-state > div { flex: 1 1; }
.pqd-state strong { color: var(--rt-text); font-weight: 600; }
.pqd-state p { margin: 2px 0 0; color: var(--rt-text-muted); font-size: var(--rt-text-xs); }

.pqd-state--error {
  border-style: solid;
  border-color: var(--danger-muted);
  background: var(--danger-muted);
  color: var(--rt-danger);
}

.pqd-grid {
  display: grid;
  gap: 16px;
  min-width: 0;
}

.pqd-grid--2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.pqd-grid--wide-left { grid-template-columns: minmax(0, 3fr) minmax(0, 2fr); }

.pqd-anchor { scroll-margin-top: calc(var(--rt-topbar-h) + 12px); }

.pqd-subheading {
  margin: 16px 0 8px;
  font-size: var(--rt-text-xs);
  font-weight: 650;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--rt-text-muted);
}

.pqd-footnote {
  margin: 8px 0 0;
  color: var(--rt-text-muted);
  font-size: var(--rt-text-xs);
}

.pqd-chip {
  display: inline-flex;
  align-items: center;
  height: 20px;
  margin-left: 8px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--bg-tertiary);
  color: var(--rt-text-secondary);
  font-size: 11px;
  font-weight: 600;
  vertical-align: middle;
}

/* ---------- C. Latest execution ---------- */

.pqd-latest__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.pqd-latest__name {
  font-size: var(--rt-text-lg);
  font-weight: 650;
  color: var(--rt-text);
}

.pqd-latest__meta {
  margin-top: 2px;
  color: var(--rt-text-muted);
  font-size: var(--rt-text-xs);
}

.pqd-latest__stats {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
  margin: 14px 0 10px;
}

.pqd-latest__stats dt {
  color: var(--rt-text-muted);
  font-size: var(--rt-text-xs);
}

.pqd-latest__stats dd {
  margin: 2px 0 0;
  font-size: 1.125rem;
  font-weight: 650;
  color: var(--rt-text);
  font-variant-numeric: tabular-nums;
}

.pqd-latest__stats dd.is-success { color: var(--rt-success); }
.pqd-latest__stats dd.is-danger { color: var(--rt-danger); }

.pqd-latest__failed h3 {
  margin: 14px 0 6px;
  font-size: var(--rt-text-xs);
  font-weight: 650;
  color: var(--rt-text-secondary);
}

.pqd-latest__failed ul,
.pqd-inline-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: var(--rt-text-sm);
}

.pqd-inline-list { margin-top: 8px; }

.pqd-latest__actions {
  display: flex;
  gap: 8px;
  margin-top: 14px;
}

.pqd-live-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--rt-info);
  animation: pqd-pulse 1.6s ease-in-out infinite;
}

@keyframes pqd-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

.pqd-progress {
  display: flex;
  height: 6px;
  overflow: hidden;
  border-radius: 999px;
  background: var(--bg-tertiary);
}

.pqd-progress--lg { height: 10px; }

.pqd-progress__seg { height: 100%; transition: width 300ms ease; }
.pqd-progress__seg--passed { background: var(--rt-success); }
.pqd-progress__seg--failed { background: var(--rt-danger); }
.pqd-progress__seg--skipped { background: var(--rt-text-muted); }
.pqd-progress__seg--pending { background: var(--rt-warning); }

/* ---------- D. Trends ---------- */

.pqd-chart {
  position: relative;
  height: 260px;
}

/* ---------- E. Failures ---------- */

.pqd-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.pqd-toolbar__right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pqd-fail-test__name {
  padding: 0;
  border: 0;
  background: none;
  color: var(--rt-text);
  font: inherit;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.pqd-fail-test__name:hover { color: var(--rt-primary); text-decoration: underline; }

.pqd-fail-test__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.pqd-tag {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 650;
}

.pqd-tag--danger { background: var(--danger-muted); color: var(--rt-danger); }
.pqd-tag--warning { background: var(--warning-muted); color: var(--rt-warning); }
.pqd-tag--info { background: var(--info-muted); color: var(--rt-info); }

.pqd-num { font-variant-numeric: tabular-nums; }

.pqd-error-line {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 360px;
  padding: 2px 6px;
  border-radius: var(--rt-radius-sm);
  background: var(--bg-tertiary);
  color: var(--rt-text-secondary);
  font-size: 11.5px;
  line-height: 1.45;
  word-break: break-word;
}

/* ---------- F. Release readiness ---------- */

.pqd-readiness__status {
  display: flex;
  gap: 10px;
  padding: 12px;
  border-radius: var(--rt-radius-md);
  background: var(--bg-tertiary);
  color: var(--rt-text-secondary);
}

.pqd-readiness__status strong { display: block; color: var(--rt-text); }
.pqd-readiness__status p { margin: 2px 0 0; font-size: var(--rt-text-xs); }
.pqd-readiness__status--success { background: var(--success-muted); color: var(--rt-success); }
.pqd-readiness__status--warning { background: var(--warning-muted); color: var(--rt-warning); }
.pqd-readiness__status--danger { background: var(--danger-muted); color: var(--rt-danger); }

.pqd-signals {
  margin: 0;
  padding: 0;
  list-style: none;
}

.pqd-signal {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid var(--rt-border-subtle);
  font-size: var(--rt-text-sm);
}

.pqd-signal:last-child { border-bottom: 0; }
.pqd-signal__label { flex: 1 1; color: var(--rt-text-secondary); }

.pqd-signal__value {
  color: var(--rt-text);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

/* ---------- G. Coverage & suites ---------- */

.pqd-coverage__head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 8px;
}

.pqd-big {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--rt-text);
  font-variant-numeric: tabular-nums;
}

.pqd-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
  color: var(--rt-text-secondary);
  font-size: var(--rt-text-xs);
}

.pqd-legend li { display: inline-flex; align-items: center; gap: 6px; }
.pqd-legend strong { color: var(--rt-text); }

.pqd-legend__dot {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background: var(--bg-tertiary);
  border: 1px solid var(--rt-border);
}

.pqd-legend__dot--passed { background: var(--rt-success); border-color: transparent; }
.pqd-legend__dot--pending { background: var(--rt-warning); border-color: transparent; }

.pqd-mini-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 14px 0 0;
}

.pqd-mini-stat {
  padding: 10px;
  border: 1px solid var(--rt-border-subtle);
  border-radius: var(--rt-radius-md);
  background: var(--rt-surface-raised, var(--rt-surface));
}

.pqd-mini-stat dt { color: var(--rt-text-muted); font-size: var(--rt-text-xs); }

.pqd-mini-stat dd {
  margin: 2px 0 0;
  font-size: var(--rt-text-lg);
  font-weight: 650;
  color: var(--rt-text);
}

.pqd-suites {
  margin: 0;
  padding: 0;
  list-style: none;
}

.pqd-suite {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 6px;
  border: 0;
  border-radius: var(--rt-radius-sm);
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.pqd-suite:hover { background: var(--rt-surface-hover); }

.pqd-suite__name {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  color: var(--rt-text);
  font-size: var(--rt-text-sm);
  font-weight: 550;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pqd-suite__meta {
  color: var(--rt-text-muted);
  font-size: var(--rt-text-xs);
  white-space: nowrap;
}

/* ---------- I. Insights ---------- */

.pqd-ai-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.pqd-insights {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.pqd-insight {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid var(--rt-border-subtle);
  border-left-width: 3px;
  border-radius: var(--rt-radius-md);
}

.pqd-insight--danger { border-left-color: var(--rt-danger); }
.pqd-insight--warning { border-left-color: var(--rt-warning); }
.pqd-insight--info { border-left-color: var(--rt-info); }
.pqd-insight--success { border-left-color: var(--rt-success); }

.pqd-insight__icon { flex-shrink: 0; margin-top: 2px; }
.pqd-insight--danger .pqd-insight__icon { color: var(--rt-danger); }
.pqd-insight--warning .pqd-insight__icon { color: var(--rt-warning); }
.pqd-insight--info .pqd-insight__icon { color: var(--rt-info); }
.pqd-insight--success .pqd-insight__icon { color: var(--rt-success); }

.pqd-insight__body { flex: 1 1; min-width: 0; font-size: var(--rt-text-sm); }
.pqd-insight__body strong { color: var(--rt-text); font-weight: 600; }

.pqd-insight__body p {
  margin: 2px 0 0;
  color: var(--rt-text-muted);
  font-size: var(--rt-text-xs);
}

/* ---------- Responsive ---------- */

@media (max-width: 1360px) {
  .pqd-kpis { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}

@media (max-width: 1080px) {
  .pqd-grid--2,
  .pqd-grid--wide-left { grid-template-columns: minmax(0, 1fr); }
  .pqd-latest__stats { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}

@media (max-width: 640px) {
  .pqd-kpis { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .pqd-header__row { flex-direction: column; }
  .pqd-filters__note { margin-left: 0; }
  .pqd-mini-stats { grid-template-columns: minmax(0, 1fr); }
  .pqd-chart { height: 220px; }
}

@media (prefers-reduced-motion: reduce) {
  .pqd-spin,
  .pqd-live-dot { animation: none; }
  .pqd-progress__seg,
  .pqd-card,
  .pqd-info__bubble { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-project-dashboard.css"],"names":[],"mappings":"AAAA,uGAAuG;;AAEvG;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,aAAa,2BAA2B,EAAE;AAC1C,aAAa,4BAA4B,EAAE;AAC3C,cAAc,gBAAgB,EAAE,qBAAqB,EAAE;AACvD,cAAc,wBAAwB,EAAE;AACxC,aAAa,uBAAuB,EAAE;;AAEtC,8CAA8C;;AAE9C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,YAAY;EACZ,yCAAyC;EACzC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA,oBAAoB,gBAAgB,EAAE;;AAEtC;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,8CAA8C;EAC9C,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,uEAAuE;AACzE;;AAEA,6BAA6B,qBAAqB,EAAE;;AAEpD;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;;;;EAIE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,gCAAgC,kBAAkB,EAAE;;AAEpD;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,YAAY,wCAAwC,EAAE;;AAEtD;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA,oBAAoB,iBAAiB,EAAE;;AAEvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,4CAA4C;EAC5C,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,+GAA+G;EAC/G,+BAA+B;EAC/B,8GAA8G;EAC9G,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,+EAA+E;EAC/E,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yFAAyF;EACzF,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA,wBAAwB,aAAa,EAAE;;AAEvC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,mBAAmB,SAAO,EAAE;AAC5B,oBAAoB,qBAAqB,EAAE,gBAAgB,EAAE;AAC7D,eAAe,eAAe,EAAE,2BAA2B,EAAE,4BAA4B,EAAE;;AAE3F;EACE,mBAAmB;EACnB,iCAAiC;EACjC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA,eAAe,gDAAgD,EAAE;AACjE,uBAAuB,oDAAoD,EAAE;;AAE7E,cAAc,kDAAkD,EAAE;;AAElE;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,8CAA8C;;AAE9C;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,mCAAmC,wBAAwB,EAAE;AAC7D,kCAAkC,uBAAuB,EAAE;;AAE3D;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,mBAAmB,eAAe,EAAE;;AAEpC;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA,oBAAoB,YAAY,EAAE;;AAElC,qBAAqB,YAAY,EAAE,4BAA4B,EAAE;AACjE,6BAA6B,6BAA6B,EAAE;AAC5D,6BAA6B,4BAA4B,EAAE;AAC3D,8BAA8B,gCAAgC,EAAE;AAChE,8BAA8B,6BAA6B,EAAE;;AAE7D,oCAAoC;;AAEpC;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,6BAA6B,wBAAwB,EAAE,0BAA0B,EAAE;;AAEnF;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB,+BAA+B,EAAE,uBAAuB,EAAE;AAC7E,oBAAoB,gCAAgC,EAAE,wBAAwB,EAAE;AAChF,iBAAiB,6BAA6B,EAAE,qBAAqB,EAAE;;AAEvE,WAAW,kCAAkC,EAAE;;AAE/C;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,+CAA+C;;AAE/C;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,gCAAgC,cAAc,EAAE,qBAAqB,EAAE;AACvE,2BAA2B,eAAe,EAAE,4BAA4B,EAAE;AAC1E,kCAAkC,gCAAgC,EAAE,wBAAwB,EAAE;AAC9F,kCAAkC,gCAAgC,EAAE,wBAAwB,EAAE;AAC9F,iCAAiC,+BAA+B,EAAE,uBAAuB,EAAE;;AAE3F;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gDAAgD;EAChD,4BAA4B;AAC9B;;AAEA,yBAAyB,gBAAgB,EAAE;AAC3C,qBAAqB,SAAO,EAAE,+BAA+B,EAAE;;AAE/D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA,+CAA+C;;AAE/C;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,iBAAiB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACtE,qBAAqB,qBAAqB,EAAE;;AAE5C;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,2BAA2B,6BAA6B,EAAE,yBAAyB,EAAE;AACrF,4BAA4B,6BAA6B,EAAE,yBAAyB,EAAE;;AAEtF;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,kCAAkC;EAClC,uDAAuD;AACzD;;AAEA,oBAAoB,2BAA2B,EAAE,4BAA4B,EAAE;;AAE/E;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mBAAmB,mCAAmC,EAAE;;AAExD;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,sCAAsC;;AAEtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA,uBAAuB,mCAAmC,EAAE;AAC5D,wBAAwB,oCAAoC,EAAE;AAC9D,qBAAqB,iCAAiC,EAAE;AACxD,wBAAwB,oCAAoC,EAAE;;AAE9D,qBAAqB,cAAc,EAAE,eAAe,EAAE;AACtD,0CAA0C,uBAAuB,EAAE;AACnE,2CAA2C,wBAAwB,EAAE;AACrE,wCAAwC,qBAAqB,EAAE;AAC/D,2CAA2C,wBAAwB,EAAE;;AAErE,qBAAqB,SAAO,EAAE,YAAY,EAAE,4BAA4B,EAAE;AAC1E,4BAA4B,qBAAqB,EAAE,gBAAgB,EAAE;;AAErE;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,qCAAqC;;AAErC;EACE,YAAY,gDAAgD,EAAE;AAChE;;AAEA;EACE;yBACuB,qCAAqC,EAAE;EAC9D,qBAAqB,gDAAgD,EAAE;AACzE;;AAEA;EACE,YAAY,gDAAgD,EAAE;EAC9D,mBAAmB,sBAAsB,EAAE;EAC3C,qBAAqB,cAAc,EAAE;EACrC,kBAAkB,qCAAqC,EAAE;EACzD,aAAa,aAAa,EAAE;AAC9B;;AAEA;EACE;kBACgB,eAAe,EAAE;EACjC;;sBAEoB,gBAAgB,EAAE;AACxC","sourcesContent":["/* Selected-project quality dashboard (pqd). Tokens only, so Cloudlight and Midnight share one sheet. */\n\n.pqd {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-bottom: 32px;\n  min-width: 0;\n}\n\n.pqd-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n\n.pqd-muted { color: var(--rt-text-muted); }\n.pqd-small { font-size: var(--rt-text-xs); }\n.pqd-strong { font-weight: 600; color: var(--rt-text); }\n.is-success { color: var(--rt-success); }\n.is-danger { color: var(--rt-danger); }\n\n/* ---------- A. Header & filters ---------- */\n\n.pqd-header {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pqd-header__row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.pqd-header__title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pqd-header__title {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--rt-text);\n}\n\n.pqd-header__desc {\n  margin: 4px 0 0;\n  max-width: 72ch;\n  color: var(--rt-text-secondary);\n  font-size: var(--rt-text-sm);\n}\n\n.pqd-header__meta {\n  margin: 4px 0 0;\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-xs);\n}\n\n.pqd-filters {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 8px;\n  border: 1px solid var(--rt-border-subtle);\n  border-radius: var(--rt-radius-lg);\n  background: var(--rt-surface);\n}\n\n.pqd-filters__env { min-width: 180px; }\n\n.pqd-filters__note {\n  margin-left: auto;\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-xs);\n}\n\n.pqd-segmented {\n  display: inline-flex;\n  padding: 2px;\n  border-radius: var(--rt-radius-md);\n  background: var(--bg-tertiary);\n}\n\n.pqd-segmented__item {\n  height: 28px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: calc(var(--rt-radius-md) - 2px);\n  background: transparent;\n  color: var(--rt-text-secondary);\n  font: inherit;\n  font-size: var(--rt-text-xs);\n  font-weight: 600;\n  cursor: pointer;\n  transition: background var(--rt-transition), color var(--rt-transition);\n}\n\n.pqd-segmented__item:hover { color: var(--rt-text); }\n\n.pqd-segmented__item.is-active {\n  background: var(--rt-surface);\n  color: var(--rt-primary);\n  box-shadow: var(--rt-shadow-sm);\n}\n\n.pqd-segmented__item:focus-visible,\n.pqd-info:focus-visible,\n.pqd-suite:focus-visible,\n.pqd-fail-test__name:focus-visible {\n  outline: 2px solid var(--rt-primary);\n  outline-offset: 2px;\n}\n\n.pqd-custom-range {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  color: var(--rt-text-muted);\n}\n\n.pqd-date {\n  height: 30px;\n  padding: 0 8px;\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-sm);\n  background: var(--rt-surface);\n  color: var(--rt-text);\n  font: inherit;\n  font-size: var(--rt-text-xs);\n  color-scheme: light;\n}\n\n[data-theme=\"dark\"] .pqd-date { color-scheme: dark; }\n\n.pqd-field-error {\n  color: var(--rt-danger);\n  font-size: var(--rt-text-xs);\n}\n\n.pqd-hint {\n  margin: 0;\n  padding: 8px 12px;\n  border-radius: var(--rt-radius-md);\n  background: var(--info-muted);\n  color: var(--rt-info);\n  font-size: var(--rt-text-sm);\n}\n\n.pqd-spin { animation: pqd-spin 0.9s linear infinite; }\n\n@keyframes pqd-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ---------- B. KPI strip ---------- */\n\n.pqd-kpis {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.pqd-kpi-skeleton { min-height: 112px; }\n\n.pqd-kpi-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pqd-info {\n  position: relative;\n  display: inline-flex;\n  color: var(--rt-text-muted);\n  cursor: help;\n  border-radius: 50%;\n}\n\n.pqd-info__bubble {\n  position: absolute;\n  z-index: 30;\n  left: 50%;\n  bottom: calc(100% + 8px);\n  width: 240px;\n  padding: 8px 10px;\n  border-radius: var(--rt-radius-md);\n  background: var(--chart-tooltip-bg, #0f172a);\n  color: var(--chart-tooltip-text, #f8fafc);\n  font-size: 11.5px;\n  font-weight: 500;\n  line-height: 1.45;\n  text-transform: none;\n  letter-spacing: 0;\n  white-space: normal;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);\n  transform: translateX(-50%);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 120ms ease;\n}\n\n.pqd-info:hover .pqd-info__bubble,\n.pqd-info:focus-visible .pqd-info__bubble {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* ---------- Section card ---------- */\n\n.pqd-card {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  border: 1px solid var(--rt-border-subtle);\n  border-radius: 14px;\n  background: linear-gradient(180deg, color-mix(in srgb, var(--rt-surface) 94%, #fff) 0%, var(--rt-surface) 100%);\n  box-shadow: var(--rt-shadow-sm);\n  transition: opacity var(--rt-transition), border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n  overflow: hidden;\n  position: relative;\n}\n\n.pqd-card::before {\n  content: '';\n  position: absolute;\n  inset: 0 0 auto 0;\n  height: 2px;\n  background: linear-gradient(90deg, var(--rt-primary, #2563eb), transparent 80%);\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.pqd-card:hover {\n  border-color: color-mix(in srgb, var(--rt-primary, #2563eb) 22%, var(--rt-border-subtle));\n  box-shadow: 0 14px 28px -18px rgba(15, 23, 42, 0.28);\n  transform: translateY(-1px);\n}\n\n.pqd-card--refreshing { opacity: 0.72; }\n\n.pqd-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px 0;\n}\n\n.pqd-card__title {\n  margin: 0;\n  font-size: var(--rt-text-base);\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  color: var(--rt-text);\n}\n\n.pqd-card__subtitle {\n  margin: 2px 0 0;\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-xs);\n}\n\n.pqd-card__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.pqd-card__body {\n  padding: 12px 16px 16px;\n  min-width: 0;\n  flex: 1;\n}\n\n.pqd-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 4px 0;\n}\n\n.pqd-state {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 14px;\n  border: 1px dashed var(--rt-border);\n  border-radius: var(--rt-radius-md);\n  color: var(--rt-text-secondary);\n  font-size: var(--rt-text-sm);\n}\n\n.pqd-state > div { flex: 1; }\n.pqd-state strong { color: var(--rt-text); font-weight: 600; }\n.pqd-state p { margin: 2px 0 0; color: var(--rt-text-muted); font-size: var(--rt-text-xs); }\n\n.pqd-state--error {\n  border-style: solid;\n  border-color: var(--danger-muted);\n  background: var(--danger-muted);\n  color: var(--rt-danger);\n}\n\n.pqd-grid {\n  display: grid;\n  gap: 16px;\n  min-width: 0;\n}\n\n.pqd-grid--2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.pqd-grid--wide-left { grid-template-columns: minmax(0, 3fr) minmax(0, 2fr); }\n\n.pqd-anchor { scroll-margin-top: calc(var(--rt-topbar-h) + 12px); }\n\n.pqd-subheading {\n  margin: 16px 0 8px;\n  font-size: var(--rt-text-xs);\n  font-weight: 650;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--rt-text-muted);\n}\n\n.pqd-footnote {\n  margin: 8px 0 0;\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-xs);\n}\n\n.pqd-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  margin-left: 8px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--bg-tertiary);\n  color: var(--rt-text-secondary);\n  font-size: 11px;\n  font-weight: 600;\n  vertical-align: middle;\n}\n\n/* ---------- C. Latest execution ---------- */\n\n.pqd-latest__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.pqd-latest__name {\n  font-size: var(--rt-text-lg);\n  font-weight: 650;\n  color: var(--rt-text);\n}\n\n.pqd-latest__meta {\n  margin-top: 2px;\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-xs);\n}\n\n.pqd-latest__stats {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 12px;\n  margin: 14px 0 10px;\n}\n\n.pqd-latest__stats dt {\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-xs);\n}\n\n.pqd-latest__stats dd {\n  margin: 2px 0 0;\n  font-size: 1.125rem;\n  font-weight: 650;\n  color: var(--rt-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.pqd-latest__stats dd.is-success { color: var(--rt-success); }\n.pqd-latest__stats dd.is-danger { color: var(--rt-danger); }\n\n.pqd-latest__failed h3 {\n  margin: 14px 0 6px;\n  font-size: var(--rt-text-xs);\n  font-weight: 650;\n  color: var(--rt-text-secondary);\n}\n\n.pqd-latest__failed ul,\n.pqd-inline-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 14px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-size: var(--rt-text-sm);\n}\n\n.pqd-inline-list { margin-top: 8px; }\n\n.pqd-latest__actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.pqd-live-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--rt-info);\n  animation: pqd-pulse 1.6s ease-in-out infinite;\n}\n\n@keyframes pqd-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.3; }\n}\n\n.pqd-progress {\n  display: flex;\n  height: 6px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: var(--bg-tertiary);\n}\n\n.pqd-progress--lg { height: 10px; }\n\n.pqd-progress__seg { height: 100%; transition: width 300ms ease; }\n.pqd-progress__seg--passed { background: var(--rt-success); }\n.pqd-progress__seg--failed { background: var(--rt-danger); }\n.pqd-progress__seg--skipped { background: var(--rt-text-muted); }\n.pqd-progress__seg--pending { background: var(--rt-warning); }\n\n/* ---------- D. Trends ---------- */\n\n.pqd-chart {\n  position: relative;\n  height: 260px;\n}\n\n/* ---------- E. Failures ---------- */\n\n.pqd-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.pqd-toolbar__right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pqd-fail-test__name {\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--rt-text);\n  font: inherit;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n}\n\n.pqd-fail-test__name:hover { color: var(--rt-primary); text-decoration: underline; }\n\n.pqd-fail-test__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.pqd-tag {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 7px;\n  border-radius: 999px;\n  font-size: 10.5px;\n  font-weight: 650;\n}\n\n.pqd-tag--danger { background: var(--danger-muted); color: var(--rt-danger); }\n.pqd-tag--warning { background: var(--warning-muted); color: var(--rt-warning); }\n.pqd-tag--info { background: var(--info-muted); color: var(--rt-info); }\n\n.pqd-num { font-variant-numeric: tabular-nums; }\n\n.pqd-error-line {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  max-width: 360px;\n  padding: 2px 6px;\n  border-radius: var(--rt-radius-sm);\n  background: var(--bg-tertiary);\n  color: var(--rt-text-secondary);\n  font-size: 11.5px;\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n/* ---------- F. Release readiness ---------- */\n\n.pqd-readiness__status {\n  display: flex;\n  gap: 10px;\n  padding: 12px;\n  border-radius: var(--rt-radius-md);\n  background: var(--bg-tertiary);\n  color: var(--rt-text-secondary);\n}\n\n.pqd-readiness__status strong { display: block; color: var(--rt-text); }\n.pqd-readiness__status p { margin: 2px 0 0; font-size: var(--rt-text-xs); }\n.pqd-readiness__status--success { background: var(--success-muted); color: var(--rt-success); }\n.pqd-readiness__status--warning { background: var(--warning-muted); color: var(--rt-warning); }\n.pqd-readiness__status--danger { background: var(--danger-muted); color: var(--rt-danger); }\n\n.pqd-signals {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.pqd-signal {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--rt-border-subtle);\n  font-size: var(--rt-text-sm);\n}\n\n.pqd-signal:last-child { border-bottom: 0; }\n.pqd-signal__label { flex: 1; color: var(--rt-text-secondary); }\n\n.pqd-signal__value {\n  color: var(--rt-text);\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  text-align: right;\n}\n\n/* ---------- G. Coverage & suites ---------- */\n\n.pqd-coverage__head {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.pqd-big {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--rt-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.pqd-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 16px;\n  margin: 8px 0 0;\n  padding: 0;\n  list-style: none;\n  color: var(--rt-text-secondary);\n  font-size: var(--rt-text-xs);\n}\n\n.pqd-legend li { display: inline-flex; align-items: center; gap: 6px; }\n.pqd-legend strong { color: var(--rt-text); }\n\n.pqd-legend__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--rt-border);\n}\n\n.pqd-legend__dot--passed { background: var(--rt-success); border-color: transparent; }\n.pqd-legend__dot--pending { background: var(--rt-warning); border-color: transparent; }\n\n.pqd-mini-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin: 14px 0 0;\n}\n\n.pqd-mini-stat {\n  padding: 10px;\n  border: 1px solid var(--rt-border-subtle);\n  border-radius: var(--rt-radius-md);\n  background: var(--rt-surface-raised, var(--rt-surface));\n}\n\n.pqd-mini-stat dt { color: var(--rt-text-muted); font-size: var(--rt-text-xs); }\n\n.pqd-mini-stat dd {\n  margin: 2px 0 0;\n  font-size: var(--rt-text-lg);\n  font-weight: 650;\n  color: var(--rt-text);\n}\n\n.pqd-suites {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.pqd-suite {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px 6px;\n  border: 0;\n  border-radius: var(--rt-radius-sm);\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.pqd-suite:hover { background: var(--rt-surface-hover); }\n\n.pqd-suite__name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  color: var(--rt-text);\n  font-size: var(--rt-text-sm);\n  font-weight: 550;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pqd-suite__meta {\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-xs);\n  white-space: nowrap;\n}\n\n/* ---------- I. Insights ---------- */\n\n.pqd-ai-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pqd-insights {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.pqd-insight {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid var(--rt-border-subtle);\n  border-left-width: 3px;\n  border-radius: var(--rt-radius-md);\n}\n\n.pqd-insight--danger { border-left-color: var(--rt-danger); }\n.pqd-insight--warning { border-left-color: var(--rt-warning); }\n.pqd-insight--info { border-left-color: var(--rt-info); }\n.pqd-insight--success { border-left-color: var(--rt-success); }\n\n.pqd-insight__icon { flex-shrink: 0; margin-top: 2px; }\n.pqd-insight--danger .pqd-insight__icon { color: var(--rt-danger); }\n.pqd-insight--warning .pqd-insight__icon { color: var(--rt-warning); }\n.pqd-insight--info .pqd-insight__icon { color: var(--rt-info); }\n.pqd-insight--success .pqd-insight__icon { color: var(--rt-success); }\n\n.pqd-insight__body { flex: 1; min-width: 0; font-size: var(--rt-text-sm); }\n.pqd-insight__body strong { color: var(--rt-text); font-weight: 600; }\n\n.pqd-insight__body p {\n  margin: 2px 0 0;\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-xs);\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 1360px) {\n  .pqd-kpis { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n}\n\n@media (max-width: 1080px) {\n  .pqd-grid--2,\n  .pqd-grid--wide-left { grid-template-columns: minmax(0, 1fr); }\n  .pqd-latest__stats { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n}\n\n@media (max-width: 640px) {\n  .pqd-kpis { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .pqd-header__row { flex-direction: column; }\n  .pqd-filters__note { margin-left: 0; }\n  .pqd-mini-stats { grid-template-columns: minmax(0, 1fr); }\n  .pqd-chart { height: 220px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pqd-spin,\n  .pqd-live-dot { animation: none; }\n  .pqd-progress__seg,\n  .pqd-card,\n  .pqd-info__bubble { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
